/**
 * Lời gọi API tra cứu nhật ký thao tác — MH-38 (chỉ đọc, không có hàm sửa/xoá
 * nào trong tệp này vì máy chủ không khai báo điểm cuối tương ứng) — đợt 3 phần
 * C4. Khớp `apps/api/src/nhat-ky-thao-tac/nhat-ky.controller.ts`.
 */
import { goi, chuoiTruyVan } from './goi-chung';

export interface DongNhatKy {
  id: string;
  thoiDiem: string;
  tenDangNhap: string;
  diaChiIp: string | null;
  maThaoTac: string;
  loaiDoiTuong: string | null;
  maDoiTuong: string | null;
  moTa: string | null;
  giaTriTruoc: unknown;
  giaTriSau: unknown;
  ketQua: string;
}

export interface TrangDuLieu<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

export interface BoLocNhatKy {
  page?: number;
  pageSize?: number;
  nguoiThucHien?: string;
  maThaoTac?: string;
  loaiDoiTuong?: string;
  maDoiTuong?: string;
  diaBan?: string;
  tuThoiDiem?: number;
  denThoiDiem?: number;
}

export const nhatKyApi = {
  traCuu(bo: BoLocNhatKy = {}, signal?: AbortSignal): Promise<TrangDuLieu<DongNhatKy>> {
    return goi(`/api/v1/audit-log${chuoiTruyVan({ ...bo })}`, { signal });
  },
};
